import { render, staticRenderFns } from "./RealEstateTableCard.vue?vue&type=template&id=21b17d90&scoped=true"
import script from "./RealEstateTableCard.vue?vue&type=script&lang=ts"
export * from "./RealEstateTableCard.vue?vue&type=script&lang=ts"
import style0 from "./RealEstateTableCard.vue?vue&type=style&index=0&id=21b17d90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b17d90",
  null
  
)

export default component.exports